export default [{
    path: 'global-add-fund-modal/:page_url',
    name: 'global-add-fund-modal',
    component: () => import ('source/components/employers/paymentdues/AddFundsModal.vue'),
    props: true,
    meta: {
        title: 'Add Funds - HQZen',
        canDisplayGlobalModals: false
    }
}];
